import { findLastIndex } from 'lodash-es'

export const getLastAdjustSetting = (list, id) => {
  return getLastSetting(list, id, (name) => {
    return (name === 'adjust' || name === 'revert')
  })
}

export const getLastFiltersSetting = (list, id) => {
  return getLastSetting(list, id, (name) => {
    return (name === 'filters' || name === 'revert')
  })
}

export const getLastPhysicsSetting = (list, id) => {
  return getLastSetting(list, id, (name) => {
    return (name === 'crop' || name === 'resize' || name === 'rotate' || name === 'revert')
  })
}

export const getLastSetting = (list, id, nameChecker) => {
  const settings = list.filter(
    (setting) => setting.id <= id && (nameChecker ? nameChecker(setting.name) : true)
  )

  return settings.length ? settings[settings.length - 1] : null
}

/**
 * Get the very last setting in list (if any) regardless of currentSettingId
 *
 * @param list
 * @returns {*|null}
 */
export const getLatestSetting = (list) => {
  return list.length ? list[list.length - 1] : null
}

export const checkHasCommittedChanges = (list, id) => {
  const lastRevertIndex = findLastIndex(list, (setting) => setting.name === 'revert')
  // check either from the beginning or from the next setting after last revert
  const startIndex = lastRevertIndex !== -1 ? lastRevertIndex + 1 : 0

  return !!list.slice(startIndex).filter(
    (setting) => setting.id <= id && setting.isCommitted
  ).length
}

export const convertToRange = (value, fromRange, toRange) => {
  return (((value - fromRange[0]) / (fromRange[1] - fromRange[0])) * (toRange[1] - toRange[0])) + toRange[0]
}

export const convertValueToPercent = (value, original) => {
  return value / original * 100
}

export const convertPercentToValue = (percent, original) => {
  return percent / 100 * original
}

export const getFilenameComponents = (filename) => {
  const rawName = filename.split('.')
  const name = rawName.slice(0, -1).join('.')
  const format = rawName[rawName.length - 1].toLowerCase()

  return { name, format }
}

export const findPresetById = (presets, id) => {
  return presets.find((preset) => preset.id === id) || null
}

export const simplePointerEventsData = (() => {
  const isTouch = 'ontouchstart' in window

  return {
    isTouch,
    pointerdown: isTouch ? 'touchstart' : 'mousedown',
    pointerup: isTouch ? 'touchend' : 'mouseup',
    pointermove: isTouch ? 'touchmove' : 'mousemove'
  }
})()

export const getLocale = () => {
  const i18nextLng = localStorage.getItem('i18nextLng')

  return i18nextLng ?
    (i18nextLng === 'ru' ? 'ru' : 'en') :
    navigator.language.match(/[a-z]+/)[0]
}
